import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function SocialProofSection() {
  const quotes = [{
    text: 'Un informe bien hecho te apura hasta los pagos.',
    author: 'Constructor',
    location: 'Santiago'
  }, {
    text: 'Justo la semana pasada perdí el celular y perdí muchísima información.',
    author: 'Subcontratista',
    location: 'AC'
  }, {
    text: 'Es una lata andar pasando foto por foto en el Word.',
    author: 'Constructor',
    location: 'Santiago'
  }];
  return <section className="py-12 sm:py-16 bg-white border-t border-gray-200" data-id="element-297">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
        <div className="text-center mb-10 sm:mb-12" data-id="element-299">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900" data-id="element-300">
            Lo que dicen en obra
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-301">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200 shadow-sm relative" data-id="element-302">
              <Quote className="absolute top-6 left-6 w-8 h-8 text-blue-200" data-id="element-303" />
              <p className="text-lg text-gray-800 font-medium leading-relaxed mb-6 relative z-10 pt-6" data-id="element-304">
                "{quote.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-305">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-sm" data-id="element-306">
                  {quote.author.charAt(0)}
                </div>
                <div data-id="element-307">
                  <p className="text-sm font-bold text-gray-900" data-id="element-308">
                    {quote.author}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-309">{quote.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}